import React from 'react';
import { Patient } from 'types/patient';
import PatientItemModule from './PatientItemModule';
import List from 'components/list/List';

type PatientListModuleProps = {
  patients: Patient[];
};

const PatientListModule: React.FC<PatientListModuleProps> = ({ patients }) => {
  return (
    <List>
      {patients.map(patient => (
        <PatientItemModule key={patient.id} patient={patient} />
      ))}
    </List>
  );
};

export default PatientListModule;
